import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Menu.css';
import menuPDF from '../../media/Cronulla.pdf';
import corporateLunchPDF from '../../media/corporateLunch.pdf';
import lunchSpecialsPDF from '../../media/lunchSpecials.pdf';
const MenuList = ({ item }) => {
    return (
        <Col className="mx-auto d-flex align-items-start justify-content-between col-12">
            <span className="text-start me-auto d-flex align-items-start">
                <span className="text-start">
                    <p className="m-0 ">{item.name}</p>
                    <small className="m-0 text-muted">{item.info}</small>
                </span>
            </span>
            <p className="m-0 text-end ms-auto">${item.price}</p>
        </Col>
    );
}

const items = {
    starters: [
        {
            itemID: 1,
            name: "Garlic Bread",
            price: 7,
            type: "starters"
        },
        {
            itemID: 2,
            name: "Herb Bread",
            price: 7,
            type: "starters"
        },
        {
            itemID: 3,
            name: "Marinated Mixed Olives",
            price: 7,
            type: "starters"
        },
        {
            itemID: 4,
            name: "Biltong",
            price: 16.99,
            type: "starters",
            info: "Dried & Cured Prime beef served with chimichurry sauce"

        },
        {
            itemID: 5,
            name: "Bone Marrow",
            price: 19.99,
            type: "starters",
            info: "Served with chimichurry sauce & bread"
        },
    ],

    entrees: [
        {
            itemID: 6,
            name: "Wagyu Beef carpaccio",
            price: 29.99,
            type: "entrees",
            info: "served with shoyuzuke egg yolk & truffle oil"
        },
        {
            itemID: 7,
            name: "Garlic & Wine Prawns ",
            price: 20.99,
            type: "entrees",
            info: "served with Turkish bread "
        },
        {
            itemID: 8,
            name: "Char Char Wings",
            price: 15.99,
            type: "entrees",
            info: "Char-grilled wings served with our secret basting sauce"
        },
        {
            itemID: 9,
            name: "Garlic Mushroom",
            price: 15.99,
            type: "entrees",
            info: "Cooked with garlic butter and wine"
        },
        {
            itemID: 10,
            name: "Panko Risotto Balls",
            price: 13.99,
            type: "entrees",
            info: "Served on top of wild rocket & glazed with spicy aioli"
        },
        {
            itemID: 11,
            name: "Scallops",
            price: 16.99,
            type: "entrees",
            info: "Served with pea puree"
        },
        {
            itemID: 12,
            name: "Salt & Pepper Squid",
            price: 16.99,
            type: "entrees",
            info: "Served with mixed lettuce, aioli & balsamic glaze"
        },
        {
            itemID: 13,
            name: "Fried Calamari",
            price: 16.99,
            type: "entrees",
            info: "Served with mixed lettuce, tartar sauce "
        },
        {
            itemID: 14,
            name: "Natural Oyster Half/Full",
            price: "22.99/42.99",
            type: "entrees",
            info: "Served with tabasco pearl & lemon wedges"
        },
        {
            itemID: 15,
            name: "Rockefeller Oyster Half/Full",
            price: "25.99/45.99",
            type: "entrees",
            info: "Served with parmesan & lemon wedges"
        },
        {
            itemID: 16,
            name: "Loaded Potato Skin",
            price: 15.99,
            type: "entrees",
            info: "Deep fried potato skin loaded with slow cooked pulled beef & spicy aioli"
        },
        {
            itemID: 17,
            name: "Portabello Mushroom",
            price: 14.99,
            type: "entrees",
            info: "Loaded with bacon and fetta"
        },
    ],
    salad: [
        //Salad
        {
            itemID: 18,
            name: "Mixed salad",
            price: 14.90,
            type: "salad",
            info: "Mesclun lettuce, tomato, onion, cucumber, capsicum & herb vinegar dressing"
        },
        {
            itemID: 19,
            name: "Mediterranean Salad",
            price: 16.90,
            type: "salad",
            info: "Mesclun lettuce, tomato, cucumber, kalamata olives, red onion, fetta cheese & Mediterranean dressing"
        },
        {
            itemID: 20,
            name: "Caesar Salad",
            price: 16.90,
            type: "salad",
            info: "Cos lettuce, egg, croutons, bacon, shaved parmesan, anchovies & ceasar dressing"
        },
        {
            itemID: 21,
            name: "Organic Beetroot & Fetta Salad",
            price: 16.90,
            type: "salad",
            info: "Mesclun lettuce, tomato, onion, cucumber, capsicum, organic beetroot, fetta & herb vinegar dressing"
        },
        {
            itemID: 22,
            name: "Rocket Salad",
            price: 16.90,
            type: "salad",
            info: "Baby rocket leaf, tomatoes, onion, kalamata olives, shaved parmesan, almond flakes & herb vinegar dressing"
        },
        {
            itemID: 23,
            name: "Prawn and Avocado Salad",
            price: 20.90,
            type: "salad",
            info: "Iceberg lettuce, avocado, cucumber, red onion, fetta cheese, prawns, almond flakes & Mediterranean dressing"
        },
        {
            itemID: 24,
            name: "Sprouted Lentil and Halloumi Salad",
            price: 17.90,
            type: "salad",
            info: "Sprouted lentil salad w/ tomato, halloumi & herb vinegar dressing"
        },
        {
            itemID: 25,
            name: "Seafood Salad",
            price: 24,
            type: "salad",
            info: "Grilled calamari, fried calamari, prawns, mixed lettuce, tomato, onion, cucumber & herb vinegar dressing"
        }
    ],

    kids: [
        {
            itemID: 26,
            name: "Panko Chicken Bites & chips",
            price: 9.50,
            type: "kids"
        },
        {
            itemID: 27,
            name: "Arancini Balls & chips",
            price: 9.50,
            type: "kids"
        },
        {
            itemID: 28,
            name: "Burger & chips ",
            price: 12.90,
            type: "kids"
        },
        {
            itemID: 29,
            name: "Steak & chips",
            price: 15.90,
            type: "kids"
        },
        {
            itemID: 30,
            name: "Fish & chips",
            price: 15.90,
            type: "kids"
        },
        {
            itemID: 31,
            name: "Jr. Beef ribs & chips",
            price: 19.90,
            type: "kids"
        },
    ],

    addProtein: [
        {
            itemID: 32,
            name: "Grilled Halloumi",
            price: 5.90,
            type: "add-protein"
        },
        {
            itemID: 33,
            name: "Grilled Chicken breast",
            price: 9.90,
            type: "add-protein"
        },
        {
            itemID: 34,
            name: "Grilled Steak",
            price: 14.90,
            type: "add-protein"
        },
    ],

    burgers: [
        {
            itemID: 35,
            name: "500 Degrees Classic",
            price: 17.99,
            type: "burgers",
            info: "200gm beef patty grilled on an open flame with our secret basting. Lettuce, tomato, onion, spiced pickle & aioli"
        },
        {
            itemID: 36,
            name: "500 Degrees Smokey",
            price: 22.99,
            type: "burgers",
            info: "200gm beef patty grilled on an open flame with our secret basting. Lettuce, tomato, onion, spiced pickle & smokey Aioli"
        },
        {
            itemID: 37,
            name: "Wagyu Beef",
            price: 22.99,
            type: "burgers",
            info: "200gm seasoned wagyu beef patty Grilled on an open flame, Lettuce, tomato, onion, spiced pickle & mustard aioli"
        },
        {
            itemID: 38,
            name: "Fatty Beef Burger ",
            price: 24.99,
            type: "burgers",
            info: "200gm beef patty grilled on an open flame with our secret basting, Garnish, cheese slice, beetroot, bacon & mustard aioli"
        },
        {
            itemID: 39,
            name: "Friday Night",
            price: 24.99,
            type: "burgers",
            info: "200gm seasoned wagyu beef patty grilled on an open flame, Lettuce, tomato, onion, spiced pickle, onion ring, cheese & aioli"
        },
        {
            itemID: 40,
            name: "Pulled Beef",
            price: 19.99,
            type: "burgers",
            info: "200gm slow cooked pulled beef with crispy onion ring, garnish, pickle & mustard aioli "
        },
        {
            itemID: 41,
            name: "Grilled Chicken",
            price: 17.99,
            type: "burgers",
            info: "Chicken breast grilled on an open flame with our secret Basting. Lettuce, tomato, onion, spiced pickle & mustard aioli."
        },
        {
            itemID: 42,
            name: "Hot chick",
            price: 17.99,
            type: "burgers",
            info: "Panko chicken breast, American cheese, Piri Piri sauce, Lettuce, tomato, onion, spiced pickle & spicy aioli"
        },
        {
            itemID: 43,
            name: "Magic Mushroom",
            price: 15.99,
            type: "burgers",
            info: "Panko crumbed mushroom, grilled haloumi, garnish & mustard aioli"
        },
        {
            itemID: 44,
            name: "Steak sando",
            price: 24.99,
            type: "burgers",
            info: "Basted grill steak, Turkish bread stuffed with rocket leaves, onion, tomato, cucumber & Aioli"
        },
    ],

    chicken: [
        {
            itemID: 45,
            name: "Full Chicken BBQ / Piri Piri",
            price: 28.90,
            type: "chicken"
        },
        {
            itemID: 46,
            name: "1/2 Chicken BBQ / Piri Piri ",
            price: 17.90,
            type: "chicken"
        },
        {
            itemID: 47,
            name: "Chicken Breast BBQ / Piri Piri ",
            price: 24.90,
            type: "chicken"
        },
        {
            itemID: 48,
            name: "Chicken Wings BBQ / Piri Piri ",
            price: 19.90,
            type: "chicken"
        },
    ],

    premium: [
        //Premium Steaks
        {
            itemID: 49,
            name: "Darling Down QLD Rump 300g",
            price: 32.90,
            type: "premium-steaks"
        },
        {
            itemID: 50,
            name: "Margaret River WA Sirloin 300g",
            price: 39.90,
            type: "premium-steaks"
        },
        {
            itemID: 51,
            name: "Western Downs QLD Scotch fillet 300g",
            price: 41.90,
            type: "premium-steaks"
        },
        {
            itemID: 52,
            name: "New England Beef T-bone 400g",
            price: 43.90,
            type: "premium-steaks"
        },
        {
            itemID: 53,
            name: "Darling Downs Eye Fillet 250g",
            price: 45.90,
            type: "premium-steaks"
        },
        {
            itemID: 54,
            name: "Riverina Lamb cutlets (Basted) 4pcs",
            price: 39.90,
            type: "premium-steaks"
        }
    ],

    wagyu: [
        //Wagyu Steaks
        {
            itemID: 55,
            name: "Black Opal Scotch fillet 250g (MB4+)",
            price: 65.90,
            type: "wagyu-steak"
        },
        {
            itemID: 56,
            name: "Tajima Wagyu New York 250g (MB5+)",
            price: 52.90,
            type: "wagyu-steak"
        },
        {
            itemID: 57,
            name: "Rangers Valley Wagyu Rump 500g (MB4+)",
            price: 55.90,
            type: "wagyu-steak"
        }
    ],

    dryage: [
        //Dry age steaks
        {
            itemID: 59,
            name: "Dry Aged bone in Striploin 300g 30 days",
            price: 65.90,
            type: "dry-age-steaks"
        },
        {
            itemID: 60,
            name: "Dry Aged bone in Striploin 300g 60 days",
            price: 85.90,
            type: "dry-age-steaks"
        },
        {
            itemID: 61,
            name: "Dry Aged Prime Rib on the bone 350g 30 days",
            price: 95.90,
            type: "dry-age-steaks"
        },
        {
            itemID: 62,
            name: "Dry Aged Prime Rib on the bone 350g 60 days",
            price: 95.90,
            type: "dry-age-steaks"
        },
    ],

    ssteaks: [
        {
            itemID: 107,
            name: "Ebony Angus Tomahawk 1.2 kilo",
            price: 119.90,
            type: "ssteaks",
        },
        {
            itemID: 108,
            name: "Wulkuraka QLD Kangaroo Loin 300g",
            price: 29.90,
            type: "steaks",
            info: "Served with chimichurry sauce and mash"
        },
    ],

    speciality: [
        {
            itemID: 63,
            name: "24 Karat Gold steak",
            price: 99.90,
            type: "500-speciality",
            info: "250g Eye Fillet wrapped with 24k gold, served with broccolini"
        },
        {
            itemID: 64,
            name: "24 Karat Gold Tomahawk",
            price: 299.90,
            type: "500-speciality",
            info: "1.2 kg Tomahawk wrapped with 24k gold, served with broccolini"
        },
        {
            itemID: 65,
            name: "Flamed Steak",
            price: 69.90,
            type: "500-speciality",
            info: "400g T bone served with one choice of either roasted rosemary potatoes, salad or chips"
        },
        {
            itemID: 66,
            name: "Pork Knuckle",
            price: 35.90,
            type: "500-speciality",
            info: "Served with mash and basting sauce"
        },
        {
            itemID: 67,
            name: "Boerewors (300g)",
            price: 25.90,
            type: "500-speciality",
            info: "South African 100% beef sausage, served with mash"
        },
        {
            itemID: 68,
            name: "Skewered",
            price: 25.90,
            type: "500-speciality",
            info: "Skewers are open flame Char Grilled with capsicum & spanish onion. Served with one choice of either roasted rosemary potatoes, salad or chips."
        },
    ],

    ribs: [
        {
            itemID: 69,
            name: "Full Plate Angus Beef Ribs",
            price: 45.90,
            type: "ribs"
        },
        {
            itemID: 70,
            name: "1/2 Rack Angus Beef Ribs",
            price: 35.90,
            type: "ribs"
        },
        {
            itemID: 71,
            name: "Full Plate Northern Rivers Pork Ribs",
            price: 52.90,
            type: "ribs"
        },
        {
            itemID: 72,
            name: "1/2 Rack Northern Rivers Pork Ribs",
            price: 42.90,
            type: "ribs"
        },
        {
            itemID: 73,
            name: "Full Plate Clover Valley Lamb Ribs",
            price: 45.90,
            type: "ribs"
        },
        {
            itemID: 74,
            name: "1/2 Rack Clover Valley Lamb Ribs",
            price: 35.90,
            type: "ribs"
        },
        {
            itemID: 75,
            name: "Full Plate of Mix Ribs",
            price: 59.90,
            type: "ribs",
            info: "(2 Ribs of your choice)"
        },
    ],

    platter: [
        {
            itemID: 76,
            name: "Meat Platter",
            price: 99.90,
            type: "platter",
            info: "Choice of half rack of ribs, 250g rump, 2pcs Lamb cutlets & 2pcs chicken wings"
        },
        {
            itemID: 77,
            name: "Ribs Platter",
            price: 89.90,
            type: "platter",
            info: "A combination of pork, lamb & beef ribs."
        },
        {
            itemID: 78,
            name: "Braai Platter (platter for 4)",
            price: 210.00,
            type: "platter",
            info: "Beef ribs, lamb ribs, 250g rump, boerewors 300g, full chicken, chicken wings, lobster & corn"
        },
        {
            itemID: 79,
            name: "Add Half Lobster",
            price: 39.90,
            type: "platter"
        },
    ],

    combos: [
        {
            itemID: 80,
            name: "CHICKEN & RIBS",
            price: 48.90,
            type: "combos",
            info: "(1⁄2Chicken & Choice of Ribs)"
        },
        {
            itemID: 81,
            name: "CHICKEN & RUMP",
            price: 48.90,
            type: "combos",
            info: "(1⁄2Chicken & 250g Rump)"
        },
        {
            itemID: 82,
            name: "RIBS & RUMP",
            price: 48.90,
            type: "combos",
            info: "(Choice of Ribs & 250g Rump)"
        },
        {
            itemID: 83,
            name: "WINGS & RIBS",
            price: 48.90,
            type: "combos",
            info: "(4pcs Wings & Choice of Ribs)"
        },
        {
            itemID: 84,
            name: "SIRLOIN & RIBS",
            price: 62.90,
            type: "combos",
            info: "(300g Sirloin & Choice of Ribs)"
        },
    ],

    seafood: [
        {
            itemID: 85,
            name: "Catch of The Day",
            price: 29.90,
            type: "seafood",
            info: "Market fish fillet cooked with garlic butter, served with mash"
        },
        {
            itemID: 86,
            name: "Whole Barramundi",
            price: 35.90,
            type: "seafood",
            info: "Grilled whole baby Barramundi, served with capsicum salsa"
        },
        {
            itemID: 87,
            name: "Grilled Calamari",
            price: 29.90,
            type: "seafood",
            info: "2pcs whole calamari Served with capsicum salsa"
        },
        {
            itemID: 89,
            name: "Piri Piri Prawns",
            price: 39.90,
            type: "seafood",
            info: "5 pcs of grilled king prawns cooked with homemade piri piri sauce. Served on the bed of cape town rice"
        },
        {
            itemID: 90,
            name: "Seafood Platter",
            price: 99.90,
            type: "seafood",
            info: "Served with S&P calamari, prawns, fried calamari, grilled squid, fish fillet, scallop, tartar sauce & half lobster on a bed of rice"
        },
    ],
    sides: [
        {
            itemID: 91,
            name: "Sautéed broccolini",
            price: 9.00,
            type: "sides",
            info: "with Garlic butter & almond Flakes"
        },
        {
            itemID: 92,
            name: "Grilled flat beans",
            price: 9.00,
            type: "sides",
        },
        {
            itemID: 93,
            name: "Grilled Halloumi",
            price: 7.00,
            type: "sides",
        },
        {
            itemID: 94,
            name: "Sweet potato chips",
            price: 9.00,
            type: "sides",
        },
        {
            itemID: 95,
            name: "Creamy mash Potato",
            price: 9.00,
            type: "sides",
        },
        {
            itemID: 96,
            name: "Steam vegetables",
            price: 9.00,
            type: "sides",
        },
        {
            itemID: 97,
            name: "Roasted rosemary potatoes",
            price: 9.00,
            type: "sides",
        },
        {
            itemID: 98,
            name: "Chips",
            price: 7.00,
            type: "sides",
        },
        {
            itemID: 99,
            name: "Corn",
            price: 8.00,
            type: "sides",
        },

    ],

    vegeterian: [
        {
            itemID: 100,
            name: "Veggie Platter",
            price: 29.90,
            type: "vegeterian",
            info: "Served with field mushroom, steamed broccoli, roasted rosemary potatoes, halloumi cheese, arancini balls served on a base of garden salad"
        },
        {
            itemID: 101,
            name: "Plant base Burger",
            price: 25.99,
            type: "vegeterian",
            info: "Plant base patty, avocado, lettuce, tomato, onion, spiced pickle & aioli served on milk Buns with chips"
        },
        {
            itemID: 102,
            name: "Cape Town Rice",
            price: 16.90,
            type: "vegeterian",
            info: "Cooked with pumpkin, rocket & mushroom"
        },
    ],

    dessert: [
        {
            itemID: 103,
            name: "Creme Brulee ",
            price: 17.90,
            type: "dessert",
        },
        {
            itemID: 104,
            name: "Sticky Date Pudding",
            price: 17.90,
            type: "dessert",
            info: "Homemade sticky date pudding served with vanilla ice cream"
        },
        {
            itemID: 105,
            name: "Chocolate Lava Cake",
            price: 17.90,
            type: "dessert",
            info: "Homemade lava cake served with vanilla ice cream"
        },
        {
            itemID: 106,
            name: "Affogato",
            price: 19.90,
            type: "dessert",
            info: "Freshly brewed double espresso served with creamy vanilla ice cream and a shot of Franjelico with a side of fresh baked cookies"
        },
    ]
};




const MenuCronnula = () => {

    return (
        <div>
            <Header></Header>
            <section style={{ background: 'black', minHeight: '100vh' }} className="d-flex align-items-center justify-content-center">
                <div id="explore-menu" className="py-5" data-aos="fade-up">
                    <h1 className="headline fw-bold text-white">Cronulla <span className="text-warning">Menu</span></h1>
                    <p className="text-white">Lunch Specials Available Monday to Friday : 12pm-3pm</p>
                    <div className="mt-4">
                        <div className="mt-4">
                            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center pdf-btns mt-5 mb-4">
                                <a target="_blank" href={menuPDF}>
                                    <button className="btn btn-outline-light mb-3 me-lg-2">Restaurant Menu <FontAwesomeIcon icon={faCircleArrowRight} /></button>
                                </a>
                                <a target="_blank" href="https://d11db405-dc09-41be-aa30-ec5cb6a63155.filesusr.com/ugd/8f5312_ac1052927af646e5b0abf6c2431ddb95.pdf">
                                    <button className="btn btn-outline-light mb-3 me-lg-2">Drinks Menu <FontAwesomeIcon icon={faCircleArrowRight} /></button>
                                </a>
                                <a target="_blank" href={corporateLunchPDF}>
                                    <button className="btn btn-outline-light mb-3 me-lg-2">Corporate Lunch Menu <FontAwesomeIcon icon={faCircleArrowRight} /></button>
                                </a>
                                <a target="_blank" href={lunchSpecialsPDF}>
                                    <button className="btn btn-outline-light mb-3 me-lg-2">Lunch Specials <FontAwesomeIcon icon={faCircleArrowRight} /></button>
                                </a>
                                <a target="_blank" href="https://d11db405-dc09-41be-aa30-ec5cb6a63155.filesusr.com/ugd/8f5312_d345c8fac7c7455cb71eea049e8ac416.pdf">
                                    <button className="btn btn-outline-light mb-3 me-lg-2">Set Menu <FontAwesomeIcon icon={faCircleArrowRight} /></button>
                                </a>
                            </div>
                        </div>

                        {/* <div className="col-12 mx-auto text-white p-3 p-lg-5">
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Starters</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">
                                    {
                                        items.starters.map(item => <MenuList
                                            item={item}
                                        />)
                                    }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Entrees</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">
                                    {
                                        items.entrees.map(item => <MenuList
                                            item={item}
                                        />)
                                    }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Salad</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">
                                    {
                                        items.salad.map(item => <MenuList
                                            item={item}
                                        />)
                                    }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Kids</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">
                                    {
                                        items.kids.map(item => <MenuList
                                            item={item}
                                        />)
                                    }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Add Protein</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.addProtein.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Burgers</h2>
                                <p className="text-start">All our Burgers are open flame Char Grilled with our secret basting sauce. Burgers are served on milk buns & every burger is cooked fresh to order</p>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.burgers.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Chicken</h2>
                                <p className="text-start">All our chickens are open flame Char Grilled with our secret basting sauce and served with one choice of either rosemary roasted potatoes, salad or chips</p>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.chicken.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Premium Steaks</h2>
                                <p className="text-start">All premium steaks are char-grilled on an open flame, lightly seasoned with choice of your salt and can be basted in our secret basting on request. Served with one choice of either roasted rosemary potatoes, salad, chips or mash</p>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.premium.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Wagyu Steaks</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.wagyu.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Dry Age Steaks</h2>
                                <p className="text-start">Our Dry Aged beef is aged in house over a period of 30 days. The end result is succulent beef cut which oozes with flavour as a result of the dry ageing process.</p>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.dryage.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Speciality Steaks</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.ssteaks.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">500 Degree Speciality</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.speciality.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Ribs</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.ribs.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Platter</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.platter.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Range of Combos</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.combos.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Seafood</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.seafood.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Sides</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.sides.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Vegetarian</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.vegeterian.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                            <div className="mb-5 pb-5 col-12">
                                <h2 className="fw-bold text-warning text-start">Dessert</h2>
                                <hr />
                                <Row className="gy-4 mt-4 d-flex flex-column align-items-center fw-bold">                                    {
                                    items.dessert.map(item => <MenuList
                                        item={item}
                                    />)
                                }
                                </Row>
                            </div>
                              </div>
 */}


                    </div>
                </div>

            </section>

            <Footer className="pt-5"></Footer>
        </div>
    );
};

export default MenuCronnula;